"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isPrivate(ipaddress) {
    return /^(::f{4}:)?10\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/i
        .test(ipaddress) ||
        /^(::f{4}:)?192\.168\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(ipaddress) ||
        /^(::f{4}:)?172\.(1[6-9]|2\d|30|31)\.([0-9]{1,3})\.([0-9]{1,3})$/i
            .test(ipaddress) ||
        /^(::f{4}:)?127\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(ipaddress) ||
        /^(::f{4}:)?169\.254\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(ipaddress) ||
        /^f[cd][0-9a-f]{2}:/i.test(ipaddress) ||
        /^fe80:/i.test(ipaddress) ||
        /^::1$/.test(ipaddress) ||
        /^::$/.test(ipaddress);
}
exports.isPrivate = isPrivate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSXNQcml2YXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiSXNQcml2YXRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsbUJBQTJCLFNBQWlCO0lBQzFDLE1BQU0sQ0FBQywyREFBMkQ7U0FDN0QsSUFBSSxDQUFDLFNBQVMsQ0FBQztRQUNsQixtREFBbUQsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDO1FBQ25FLGtFQUFrRTthQUMvRCxJQUFJLENBQUMsU0FBUyxDQUFDO1FBQ2xCLDREQUE0RCxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUM7UUFDNUUsbURBQW1ELENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQztRQUNuRSxxQkFBcUIsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDO1FBQ3JDLFNBQVMsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDO1FBQ3pCLE9BQU8sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDO1FBQ3ZCLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUE7QUFDMUIsQ0FBQztBQVpELDhCQVlDIn0=


//////////////////
// WEBPACK FOOTER
// ./src/IsPrivate.ts
// module id = 13
// module chunks = 0